import React, {useRef} from 'react';

export const HtmlEditor = {};
export const Image = {};
export const Link = {};
export const QuickToolbar = {};
export const Toolbar = {};

export const Inject = ({ services }: { services?: any[] }) => {
  // noop: kept for compatibility with existing code that calls <Inject services={...} />
  return null as any;
};

export const RichTextEditorComponent: React.FC<{
  children?: React.ReactNode;
  className?: string;
}> = ({children, className}) => {
  const editorRef = useRef<HTMLDivElement | null>(null);

  const exec = (cmd: string, val?: string) => {
    document.execCommand(cmd, false, val || '');
    // keep focus
    editorRef.current?.focus();
  };

  const onInsertImage = () => {
    const url = prompt('Enter image URL');
    if (url) exec('insertImage', url);
  };

  const onCreateLink = () => {
    const url = prompt('Enter link URL');
    if (url) exec('createLink', url);
  };

  return (
    <div className={className || ''}>
      <div style={{display: 'flex', gap: 8, marginBottom: 8}}>
        <button type="button" onClick={() => exec('bold')}>B</button>
        <button type="button" onClick={() => exec('italic')}>I</button>
        <button type="button" onClick={() => exec('underline')}>U</button>
        <button type="button" onClick={onCreateLink}>Link</button>
        <button type="button" onClick={onInsertImage}>Image</button>
        <button type="button" onClick={() => exec('undo')}>Undo</button>
        <button type="button" onClick={() => exec('redo')}>Redo</button>
      </div>
      <div
        ref={editorRef}
        contentEditable
        suppressContentEditableWarning
        style={{minHeight: 300, border: '1px solid #e2e8f0', padding: 12, borderRadius: 6}}
      >
        {children}
      </div>
    </div>
  );
};

export default RichTextEditorComponent;
